/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'

import styles from './Breadcrumbs.module.scss'
import iconHouse from '../../assets/jnj-icon-house.svg'

const Breadcrumbs = ({ crumbs, className, sx }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <MuiBreadcrumbs
      aria-label="breadcrumb"
      className={`${styles.container} ${className ?? ''}`}
      sx={sx}
      data-testid="breadcrumbId"
    >
      <Typography
        component="button"
        onClick={() => navigate('/')}
        className={`${styles.label} ${styles.navButtonSx}`}
      >
        <img src={iconHouse} alt="home" className={styles.icon} />
        {t('home-tab')}
      </Typography>

      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1

        return isLast ? (
          <Typography
            key={index}
            aria-current="page"
            className={styles.label}
            sx={{ fontWeight: 'bold', color: 'text.primary' }}
          >
            {t(crumb.label)}
          </Typography>
        ) : (
          <Typography
            key={index}
            component="button"
            onClick={crumb.path ? () => navigate(crumb.path) : null}
            className={`${styles.label} ${
              crumb.path ? styles.navButtonSx : styles.navButtonSxWithoutLink
            }`}
          >
            {t(crumb.label)}
          </Typography>
        )
      })}
    </MuiBreadcrumbs>
  )
}

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
}

Breadcrumbs.defaultProps = {
  crumbs: [],
  className: undefined,
  sx: undefined,
}

export default Breadcrumbs
